import type * as T from './types/sync.types';
import type { PushSubscriptionLike } from './types/push-api.types';
import type { TNotifyServerSettings } from './types/client.types';

import { ERRORS, SERVER_PAYLOAD } from './settings';
import { PushNotificationsError } from './utils/error';

export function getPayload(subscription: PushSubscriptionLike) {
  const token = subscription.endpoint;

  return {
    token,
    endpoint: token,
  };
}

export function notifyServer(options: T.INotifyServerOptions) {
  return (
    status: T.TServerPayload,
    subscription: PushSubscriptionLike
  ): Promise<Response> => {
    const payload = getPayload(subscription);
    const body = {
      ...SERVER_PAYLOAD,
      status,
      application: options.application,
      token: payload.token,
    };

    return fetch(options.url, {
      method: 'post',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    })
      .then((response) => {
        if (response.status !== 200) {
          throw new PushNotificationsError(ERRORS.SERVER_SYNC);
        }
        return response.json();
      })
      .catch(() => {
        throw new PushNotificationsError(ERRORS.SERVER_SYNC);
      });
  };
}

export function createNotify(settings: TNotifyServerSettings) {
  return notifyServer({
    application: settings.application,
    url: settings.serverUrl,
  });
}
